import ErrorResults from "./ErrorResults";
import FetchErrorResults from "./FetchErrorResults";
import LoadingResults from "./LoadingResults";
import NoResults from "./NoResults";

export default {
  Error: ErrorResults,
  Loading: LoadingResults,
  FetchError: FetchErrorResults,
  None: NoResults,
};
